<template>
  <module-block
    class="home-instructions"
    block="lightest"
  >
    <h2 class="h2 home-instructions__heading mt0">The process is safe, simple and secure!</h2>
    <div class="home-instructions__inner group group--last">
      <div class="home-instructions__steps">
        <div
          v-for="(step, index) in instructionSteps"
          :key="index"

          class="home-instructions__step"
        >
          <div class="home-instructions__icon">
            <img
              :src="step.image"
              :alt="step.alt"
            >
          </div>
          <div class="home-instructions__content">
            <h4 class="home-instructions__heading h4 fw-bold">{{ step.heading }}</h4>
            <p class="p">{{ step.copy }}</p>
          </div>
          <div
            v-if="index <= instructionSteps.length - 2"

            class="home-instructions__arrow"
          >
            <img
              :src="images.arrowRight"
              alt="Next Step"
            >
          </div>
        </div>
      </div>
      <module-button
        class="home-instructions__button"
        button="primary"
        :link="isAuthenticated ? `request` : `register-patient`"
        :query="isAuthenticated ? {} : { redirect: reverseRoute(`register-patient`) }"
        size="l"
        label="Start My Request"
      />
    </div>
  </module-block>
</template>

<script>
// Modules
import ModuleBlock from 'modules/Block';
import ModuleButton from 'modules/Button';
import { mapGetters } from 'vuex';
import { reverseRoute } from 'services/router';

// Images
const images = {
  xray: require(`images/instructions/xray.svg`),
  request: require(`images/instructions/request.svg`),
  opinion: require(`images/instructions/opinion.svg`),
  arrowRight: require(`images/icons/arrow-right.svg`),
};

export default {
  name: `home-instructions`,

  // Components
  components: {
    ModuleBlock,
    ModuleButton,
  },

  // Data
  data () {
    return  {
      images,
      instructionSteps: [
        {
          image: images.xray,
          alt: `1`,
          heading: `You Request Your X\u2011Rays`,
          copy: `Once the patient creates an account, VeriTooth will email the dentist for a digital copy of the X rays. This is typically provided at no cost to the patient.`,
        },
        {
          image: images.request,
          alt: `2`,
          heading: `Your Dentist Submits Your X\u2011Rays`,
          copy: `The dental office will be provided a link to upload the x-rays to a secure location for review. All personal information will be "scrubbed" to ensure patient privacy is protected.`,
        },
        {
          image: images.opinion,
          alt: `3`,
          heading: `A Specialist Verifies The Work`,
          copy: `An impartial and qualified dental expert will compare the x-rays to clearly defined criteria for quality dental care as defined by the ADA (American Dental Association) and AAE (American Association of Endodontists)`,
        },
      ],
    };
  },

  computed: mapGetters(`auth`, [
    `isAuthenticated`,
  ]),

  methods: {
    reverseRoute,
  },

};
</script>



// WEBPACK FOOTER //
// Instructions.vue?8086155a